import App from 'App';
import 'common/styles/antd.customize.less';
import 'common/styles/global.less';
import 'common/styles/loader-theme.css';
import 'common/styles/theme.css';
import { Auth0ProviderWithHistory } from 'components/common/Auth0ProviderWithHistory';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'redux/store';
import * as serviceWorker from 'serviceWorker';
import { debugLog, setupDebugTriggers, setupFetchInterceptor } from 'utils/cacheUtils';

// Initialize cache-busting utilities
debugLog('Initializing application with cache-busting enabled');
setupFetchInterceptor();
setupDebugTriggers();

const container = document.getElementById('root') as HTMLElement;

const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <App />
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
